import {
    Message
} from "element-ui";
import {
    uploadFile
} from "../../../api/suitability";

const componentsCommon=require("cb-components-common").default;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;
const removeNameAndValue=componentsCommon.localStorage.removeNameAndValue;
const setNameAndValue=componentsCommon.localStorage.setNameAndValue;

export const importFile = {
    data() {
        return {
            importFileModel: {
                filePath: "",
                fileType: "excel",
                flag: "中国基金代码"
            },
            fileTypeOptions: [{
                    value: "excel",
                    label: "excel"
                },
                {
                    value: "csv",
                    label: "csv"
                }
            ],
            flagTypeOptions: [{
                    value: "symbol",
                    label: "中国基金代码"
                } //,
                // { value: "ticker", label: "晨星基金代码" }
            ],
        }
    },
    methods: {
        uploadSectionFile(params) {
            let self = this;
            self.dialogLoading = true;
            self.importDialogVisible = false;
            let formData = new FormData();
            if (typeof formData.set != "function") {
                formData.append("file", params.file);
            } else {
                formData.set("file", params.file);
            }
            const fileTypeValue = params.file.name.split(".")[1];
            uploadFile(formData, {
                    fileType: fileTypeValue
                })
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            removeNameAndValue("unidentifiedList");
                            result = result.data;
                            let unidentified = "";
                            if (
                                result.unidentifiedList != undefined &&
                                result.unidentifiedList.length > 0
                            ) {
                                setNameAndValue(
                                    "unidentifiedList",
                                    result.unidentifiedList
                                );
                                unidentified =
                                    "<br><a href='javascript:void(0)' onclick='showUnidentifiedData()'>下载未识别基金代码详细</a>";
                            }
                            if (result) {
                                window.showUnidentifiedData =
                                    self.showUnidentifiedData;

                                self.$alert(
                                    "成功识别基金代码：" +
                                    result.identified +
                                    ",更新数是：" +
                                    result.updated +
                                    ",未识别数是：" +
                                    result.unidentified +
                                    unidentified,
                                    "导入数据", {
                                        dangerouslyUseHTMLString: true
                                    }
                                );
                            }
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.dialogLoading = false;
                });
        },
        handleImportFile() {
            this.$refs.upload.submit();
        },
        handleShowHelp() {
            this.$alert(
                "1.请上传相关基金的六位数字中国基金代码，导入的文件必须为仅有一列数字的Excel格式文件。<br>" +
                "2.点击“导入文件”按钮，选择本地对应位置的文件。<br>" +
                "3.点击确定，系统自动识别。<br>" +
                "4.确认更新的基金数量，并下载文件中系统未能识别的基金代码详细信息（如有）。",
                "批量导入基金代码说明", {
                    confirmButtonText: "确 定",
                    confirmButtonClass: "el-button button_space el-button--primary el-button--small is-round",
                    dangerouslyUseHTMLString: true
                }
            );
        },
    }
}
